import React, { useState } from 'react';
import Media from 'react-media';
import PropTypes from 'prop-types';

import {
	makeStyles,
	useTheme
} from '@material-ui/core';

import Thumbnail from './Thumbnail.js';

const maxHeight = 400;
const minHeight = 200;
const styles = makeStyles(theme => ({
	embedResponsive: {
		position: "relative",
		display: "block",
		height: "100%",
		padding: "0",
		overflow: "hidden"
	},

	ratio16by9: {
		//paddingBottom: "28.6%"
	},

	video: {
		position: "absolute",
		top: "0",
		bottom: "0",
		left: "0",
		width: "100%",
		height: "100%",
		border: "0",
		maxHeight: minHeight,

		[theme.breakpoints.up('sm')]: {
			maxHeight: maxHeight
		}
	}
}));

function PostVideo(props) {
	const theme = useTheme();
	const [brokenVideo, setBrokenVideo] = useState(false);

	const handleError = (event) => {
		setBrokenVideo(true);
	};

	let classes = styles(),
		{useIframeVideo, video} = props;

	return (
		<div style={{height: "100%"}}>
			{!brokenVideo ? (
				<div className={`${classes.embedResponsive} ${classes.ratio16by9}`}>
					{!useIframeVideo ? (
						<video onError={handleError} className={`${classes.video}`} controls>
							<source src={video} />
						</video>
					) : (
						<iframe
							title="video"
							src={video}
							className={`${classes.video}`}
							allowFullScreen={true}
							webkitallowfullscreen="true"
							mozallowfullscreen="true"></iframe>
					)}
				</div>
			) : (
				<Media query={{minWidth: theme.breakpoints.values.sm}}>
					{matches => (
						<Thumbnail image="" center fitToHeight={matches ? maxHeight : minHeight} />
					)}
				</Media>
			)
			}
		</div>
	);
}

PostVideo.propTypes = {
	useIframeVideo: PropTypes.bool,
	video: PropTypes.string
};

export default PostVideo;